import { IonSpinner } from '@ionic/react';
import { ApexOptions } from 'apexcharts';
import * as React from 'react';

import '@/pages/ReportV2/components/Graphs/graphCard.css';

import { useEffect } from 'react';
// eslint-disable-next-line import/default
import Chart from 'react-apexcharts';

import styles from '@/pages/ReportV2/components/Graphs/ApexCharts.module.css';

import { KinematicYAxis, kinematicGraphAnnotations } from '@/models/reportV2.model';

type PelvisFunctionGraphProps = {
  data: any;
  title: string;
  subtitle: string;
  graphAnnotations: kinematicGraphAnnotations;
  strokeWidth: number;
  forPdf?: boolean;
  yAxis: KinematicYAxis;
};

// eslint-disable-next-line react/display-name
export const PelvisFunctionGraph = React.forwardRef(
  (
    { data, title, subtitle, graphAnnotations, strokeWidth, forPdf = false, yAxis }: PelvisFunctionGraphProps,
    ref: React.ForwardedRef<Chart>,
  ) => {
    const [loading, setLoading] = React.useState(!forPdf ? true : false);

    const options: ApexOptions = {
      chart: {
        type: 'line',
        width: '100%',
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
        animations: {
          enabled: false,
        },
        offsetX: forPdf ? -5 : -10,
      },
      xaxis: {
        type: 'numeric',
        labels: {
          show: false,
          style: {
            fontSize: '8px',
          },
        },
        axisTicks: {
          show: false,
        },
        title: {
          text: 'Percentage of stride time',
          style: {
            fontSize: '10px',
            fontFamily: 'Montserrat',
            fontWeight: 300,
          },
          offsetY: 5,
        },
      },
      yaxis: {
        show: true,
        min: yAxis.yMin,
        max: yAxis.yMax,
        tickAmount: yAxis.tickAmount,
        labels: {
          formatter: function (value: number) {
            return value.toFixed(0);
          },
          style: {
            fontSize: '8px',
          },
        },
        axisTicks: {
          show: true,
        },
      },
      grid: {
        show: true,
        yaxis: {
          lines: {
            show: true,
          },
        },
      },
      title: {
        text: !forPdf ? title : '',
        align: 'center',
        margin: 0,
        style: {
          fontSize: '14px',
          fontWeight: 'bold',
          fontFamily: 'Montserrat',
          color: '#707070',
        },
      },
      subtitle: {
        text: subtitle,
        align: 'center',
        margin: -10,
        floating: false,
        offsetY: 25,
        style: {
          fontSize: '10px',
          fontFamily: 'Montserrat',
        },
      },
      stroke: {
        width: strokeWidth,
        dashArray: [0, 5],
      },
      legend: {
        show: forPdf ? false : true,
        position: 'top',
        horizontalAlign: 'center',
        fontSize: '9px',
        offsetY: 0,
        markers: {
          width: 8,
          height: 8,
        },
        onItemClick: {
          toggleDataSeries: true,
        },
      },
      annotations: {
        xaxis: graphAnnotations,
        yaxis: [
          {
            y: 0,
            borderColor: 'red',
          },
        ],
      },
      markers: {
        size: [0, 0, 2],
        strokeWidth: 0,
        showNullDataPoints: false,
      },
      tooltip: {
        enabled: false,
      },
    };

    useEffect(() => {
      if (!forPdf) {
        setTimeout(() => {
          setLoading(false);
        }, 250);
      }
    }, [data]);

    return (
      <>
        <div className={styles.kinematicsGraph_Wrapper}>
          {!loading ? (
            <Chart options={options} ref={ref} series={data} type='line' />
          ) : (
            <IonSpinner color='primary' name='bubbles' />
          )}
        </div>
      </>
    );
  },
);
